import script from "./EnvironmentSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnvironmentSection.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/data.css?vue&type=style&index=0&id=75b09504&scoped=true&lang=css&external"
import "./EnvironmentSection.vue?vue&type=style&index=1&id=75b09504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b09504"]])

export default __exports__